var UAParser = require('core/utils/ua_parser');

module.exports = {
  provides: 'device_type',
  shouldTrack: true,
  isSticky: true,

  getter: [
    function() {
      var device = UAParser.get().device;

      switch (device.type) {
        case 'mobile':
          // The dimension value is 'phone', which is clearer to US English speakers.
          return 'phone';
        case 'tablet':
        case 'desktop_laptop':
          // These are already valid values for the dimension, so return them literally.
          return device.type;
        default:
          // Any other device type falls under this catch-all.
          return 'other';
      }
    }
  ]
};

